import type * as SchemaTypes from '../../../../apolloClient.types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CreateBmpAssessmentResultMutationVariables = SchemaTypes.Exact<{
  input: SchemaTypes.SubmitBmpResultInput;
}>;


export type CreateBmpAssessmentResultMutation = (
  { __typename: 'Mutation' }
  & { submitBmpResult: (
    { __typename: 'ErrorResponse' }
    & { fields?: SchemaTypes.Maybe<Array<(
      { __typename: 'ErrorOnField' }
      & Pick<SchemaTypes.ErrorOnField, 'message' | 'field'>
    )>> }
  ) | (
    { __typename: 'SubmitBmpResultSuccessfulResponse' }
    & { result?: SchemaTypes.Maybe<(
      { __typename: 'AssessmentResult' }
      & BmpAssessmentResultFragment
    )> }
  ) }
);

export type BmpAssessmentResultFragment = (
  { __typename: 'AssessmentResult' }
  & Pick<SchemaTypes.AssessmentResult, 'id' | 'companyId' | 'userId' | 'moduleInstanceId' | 'courseInstanceId' | 'assessmentRunId' | 'createdAt' | 'completedAt' | 'updatedAt' | 'updatedBy' | 'isDeleted'>
  & { company: (
    { __typename: 'Company' }
    & Pick<SchemaTypes.Company, 'id' | 'name'>
  ), user?: SchemaTypes.Maybe<(
    { __typename: 'SuperAdminUser' }
    & Pick<SchemaTypes.SuperAdminUser, 'id' | 'name' | 'email' | 'isSuperAdmin'>
  ) | (
    { __typename: 'TenantUser' }
    & Pick<SchemaTypes.TenantUser, 'id' | 'name' | 'role' | 'email'>
  )>, moduleInstance?: SchemaTypes.Maybe<(
    { __typename: 'ModuleInstance' }
    & Pick<SchemaTypes.ModuleInstance, 'name'>
  )>, courseInstance?: SchemaTypes.Maybe<(
    { __typename: 'CourseInstance' }
    & Pick<SchemaTypes.CourseInstance, 'name'>
  )>, assessmentRun?: SchemaTypes.Maybe<(
    { __typename: 'AssessmentRun' }
    & Pick<SchemaTypes.AssessmentRun, 'name'>
  )>, result: (
    { __typename: 'BmpResult' }
    & BmpAssessmentResultDataFragment
  ) | { __typename: 'CardioRespResult' } | { __typename: 'FinSwimResult' } | { __typename: 'IpptResult' } | { __typename: 'ML360Result' } | { __typename: 'March20kmResult' } | { __typename: 'SartResult' } | { __typename: 'SelfDeterminationResult' } | { __typename: 'SocResult' } | { __typename: 'SpatialPlanningResult' } | { __typename: 'StrengthResult' } | { __typename: 'TeamResilienceResult' } | { __typename: 'TrainersNotesResult' } | { __typename: 'VisualReactionResult' } | { __typename: 'WeightResult' } }
);

export type BmpAssessmentResultDataFragment = (
  { __typename: 'BmpResult' }
  & Pick<SchemaTypes.BmpResult, 'percentage'>
);

export const BmpAssessmentResultDataFragmentDoc = /*#__PURE__*/ gql`
    fragment BmpAssessmentResultData on BmpResult {
  percentage
}
    `;
export const BmpAssessmentResultFragmentDoc = /*#__PURE__*/ gql`
    fragment BmpAssessmentResult on AssessmentResult {
  id
  companyId
  company {
    id
    name
  }
  userId
  user {
    __typename
    ... on TenantUser {
      id
      name
      role
      email
    }
    ... on SuperAdminUser {
      id
      name
      email
      isSuperAdmin
    }
  }
  moduleInstanceId
  moduleInstance {
    name
  }
  courseInstanceId
  courseInstance {
    name
  }
  assessmentRunId
  assessmentRun {
    name
  }
  result {
    __typename
    ... on BmpResult {
      ...BmpAssessmentResultData
    }
  }
  createdAt
  completedAt
  updatedAt
  updatedBy
  isDeleted
}
    `;
export const CreateBmpAssessmentResultDocument = /*#__PURE__*/ gql`
    mutation CreateBmpAssessmentResult($input: SubmitBmpResultInput!) {
  submitBmpResult(input: $input) {
    __typename
    ... on SubmitBmpResultSuccessfulResponse {
      result {
        ...BmpAssessmentResult
      }
    }
    ... on ErrorResponse {
      fields {
        message
        field
      }
    }
  }
}
    ${BmpAssessmentResultFragmentDoc}
${BmpAssessmentResultDataFragmentDoc}`;
export type CreateBmpAssessmentResultMutationFn = Apollo.MutationFunction<CreateBmpAssessmentResultMutation, CreateBmpAssessmentResultMutationVariables>;

/**
 * __useCreateBmpAssessmentResultMutation__
 *
 * To run a mutation, you first call `useCreateBmpAssessmentResultMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBmpAssessmentResultMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBmpAssessmentResultMutation, { data, loading, error }] = useCreateBmpAssessmentResultMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateBmpAssessmentResultMutation(baseOptions?: Apollo.MutationHookOptions<CreateBmpAssessmentResultMutation, CreateBmpAssessmentResultMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateBmpAssessmentResultMutation, CreateBmpAssessmentResultMutationVariables>(CreateBmpAssessmentResultDocument, options);
      }
export type CreateBmpAssessmentResultMutationHookResult = ReturnType<typeof useCreateBmpAssessmentResultMutation>;
export type CreateBmpAssessmentResultMutationResult = Apollo.MutationResult<CreateBmpAssessmentResultMutation>;
export type CreateBmpAssessmentResultMutationOptions = Apollo.BaseMutationOptions<CreateBmpAssessmentResultMutation, CreateBmpAssessmentResultMutationVariables>;